import {Component, Input} from '@angular/core';
import {Events, NavController, NavParams, ViewController} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";

/**
 * Generated class for the CompleteBookingModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-complete-booking-modal',
    templateUrl: 'complete-booking-modal.html',
})
export class CompleteBookingModalPage {

    barber: any;
    booking: any;
    loading: boolean;
    errors: {};

    constructor(
      public viewCtrl: ViewController,
      public navParams: NavParams,
      public events: Events,
      private http: HttpClient,
      private apiErrorHandler: ApiErrorHandlerProvider
    ) {
        this.barber = navParams.get('barber');
        this.booking = navParams.get('booking');
    }

    completeBooking() {
        this.loading = true;
        this.booking.busy = true;

        return new Promise((resolve, reject) => {
            this.http.post(`/bookings/${this.booking.id}/complete`, {
                user_id: localStorage.getItem('tuid')
            }).subscribe((booking:any) => {
                this.errors = {};
                booking.busy = true;
                this.loading = false;
                this.viewCtrl.dismiss(booking);
                resolve(true)
            }, error => {
                this.errors = this.apiErrorHandler.handleError(error);
                reject(this.errors)
            })
        });
    }

    closeModal() {
        this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/complete-booking-modal/complete-booking-modal.ts